import React, { useEffect, useState } from 'react';
import { onAuthStateChanged, User } from 'firebase/auth';
import { auth } from './firebase';
import { ensureAdminSession } from './adminSession';

export const AuthLoader = ({ children }: { children: React.ReactElement }) => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState<User | null>(null);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const unsubscribe = onAuthStateChanged(auth, async (nextUser) => {
      if (!isMounted) {
        return;
      }

      setUser(nextUser);

      if (!nextUser) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }

      try {
        await ensureAdminSession({ forceRefresh: true });
        if (isMounted) {
          setIsAdmin(true);
        }
      } catch (error) {
        console.error('Admin session validation failed:', error);
        if (isMounted) {
          setIsAdmin(false);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    });

    return () => {
      isMounted = false;
      unsubscribe();
    };
  }, []);

  if (loading) {
    return <div>Loading auth...</div>;
  }

  if (!user) {
    return children;
  }

  if (!isAdmin) {
    return <div>Access Denied</div>;
  }

  return children;
};
